import { gql } from "@apollo/client";

export const GET_SETTINGS_TSL_SUGGESTS = gql`
  query ReadSettingsTlsSuggests {
    suggestions {
      update_license_cert_files
    }
  }
`;

export const GET_FORM_VALIDATION_SUGGESTS = gql`
  query ReadFormValidationSuggests {
    suggestions {
      validators {
        create_ipmp
        update_action_log_period
        update_ftp_masquerade_address
        update_ipmp
        update_okta_settings
        update_smtp_settings
      }
    }
  }
`;
